import { ref, readonly } from 'vue';
import { isStandaloneMode } from '~/utils/tauri-helper';

export function useIsStandalone () {
  const isStandalone = ref(isStandaloneMode());
  return readonly(isStandalone);
}
